import type { RouteObject } from 'react-router';

import { Navigate } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { chatRoutes } from 'src/pages/chat/routes/chat';
import { ticketRoutes } from 'src/pages/tickets/routes/ticket';
import { reportRoutes } from 'src/pages/reports/routes/report';
import { settingRoutes } from 'src/pages/setting/routes/setting';
import { channelRoutes } from 'src/pages/channel/routes/channel';
import { profileRoutes } from 'src/pages/setting/routes/profile';
import { contactRoutes } from 'src/pages/contacts/routes/contact';
import { accountRoutes } from 'src/pages/accounts/routes/account';
import { campaignRoutes } from 'src/pages/campaign/routes/campaign';
import { dashboardRoutes } from 'src/pages/dashborad/routes/dashboard';
import { withModulePermission } from 'src/pages/auth/hooks/withModulePermission';
import PaymentCallback from 'src/pages/setting/components/payment/payment-callback';

import { AuthGuard } from 'src/auth/guard';

import { authRoutes } from '../../pages/auth/routes/auth';
import { tenantRoutes } from '../../pages/tenants/routes/tenant';

// ----------------------------------------------------------------------

const Page404 = lazyWithReload(() => import('src/pages/error/404'));
const Page403 = lazyWithReload(() => import('src/pages/error/403'));
const PolicyPage = lazyWithReload(() => import('src/pages/policy/policy'));

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to={CONFIG.auth.redirectPath} replace />,
  },

  // Auth
  ...authRoutes,

  //Dashboard
  // ...dashboardRoutes,
  withModulePermission('dashboard', dashboardRoutes),

  //contact
  withModulePermission('contact', contactRoutes),

  // account
  // ...accountRoutes,
  withModulePermission('company', accountRoutes),

  // chat
  // ...chatRoutes,
  withModulePermission('inbox', chatRoutes),
  // // form
  // ...formRoutes,
  // ...formRoutes,

  // campaign
  // ...campaignRoutes,
  withModulePermission('campaign', campaignRoutes),

  // channel
  // ...channelRoutes,
  withModulePermission('channel', channelRoutes),

  // setting
  withModulePermission('setting', settingRoutes),

  // tenant
  // ...tenantRoutes,
  withModulePermission('tenants', tenantRoutes),

  // ticket
  // ...ticketRoutes,
  withModulePermission('ticket', ticketRoutes),

  //reports
  // ...reportRoutes,
  withModulePermission('call', reportRoutes),

  ...profileRoutes,

  // No match
  { path: '*', element: <Page404 /> },
  { path: '/policy', element: <PolicyPage /> },
  {
    path: '/403',
    element: (
      <AuthGuard>
        <Page403 />
      </AuthGuard>
    ),
  },
  {
    path: '/callback',
    element: <PaymentCallback />,
  },
];
